import { render, staticRenderFns } from "./Dispatch_date.vue?vue&type=template&id=545cd84c"
import script from "./Dispatch_date.vue?vue&type=script&lang=js"
export * from "./Dispatch_date.vue?vue&type=script&lang=js"
import style0 from "./Dispatch_date.vue?vue&type=style&index=0&id=545cd84c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports